
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useUserProfile, useUserSettings, useRoutineProgress, useClassSubscriptions } from './useBadgeQueries';
import { checkUserBadges } from './badgeAwardService';

export const useBadgeAward = () => {
  const { user } = useAuth();
  const { data: userProfile } = useUserProfile();
  const { data: userSettings } = useUserSettings();
  const { data: routineProgress } = useRoutineProgress();
  const { data: classSubscriptions } = useClassSubscriptions();

  useEffect(() => {
    if (!user || !userProfile) return;
    
    const initBadgeCheck = async () => {
      try {
        await checkUserBadges(
          user.id,
          userProfile.role,
          userSettings,
          routineProgress,
          classSubscriptions
        );
      } catch (error) {
        console.error('Error checking badges:', error);
      }
    };

    initBadgeCheck();
  }, [user, userProfile, userSettings, routineProgress, classSubscriptions]);
};
